import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as L from 'leaflet';
import { DashboardService } from '../../service/dashboard/dashboard.service';
import { RequestFormService } from '../../service/requestForm/request-form.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-deviation-map-popup',
  templateUrl: './deviation-map-popup.component.html',
  styleUrls: ['./deviation-map-popup.component.scss'],
})
export class DeviationMapPopupComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private dialogRef: MatDialogRef<DeviationMapPopupComponent>,
    private sharedDataService: DashboardService,
    private requestformservice: RequestFormService,
    private toastr: ToastrService,
  ) {}

  ngAfterViewInit() {
    const { ais_position, forecast_position } = this.data;

    // 🗺️ Initialize map
    const map = L.map('map').setView([ais_position.lat, ais_position.lon], 5);

    // 🌍 Light map layer
    L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    ).addTo(map);

    const aisIcon = this.createDeviationIcon('ais', 8);
    const forecastIcon = this.createDeviationIcon('forecast', 8);

    L.marker([ais_position.lat, ais_position.lon], { icon: aisIcon })
      .addTo(map)
      .bindTooltip('🚢 AIS Position (Actual)', { direction: 'top' });

    const forecastMarker = L.marker(
      [forecast_position.lat, forecast_position.lon],
      {
        icon: forecastIcon,
      },
    )
      .addTo(map)
      .bindTooltip('📍 Forecast Position', { direction: 'top' });

    L.circle([forecast_position.lat, forecast_position.lon], {
      radius: this.data.deviation_value * 1852,
      color: '#ef4444', 
      fillColor: '#fca5a5', 
      fillOpacity: 0.3, 
      weight: 2,
    }).addTo(map);

    // 🔗 Deviation Line
    const line = L.polyline(
      [
        [ais_position.lat, ais_position.lon],
        [forecast_position.lat, forecast_position.lon],
      ],
      {
        color: '#1890ff',
        weight: 3,
        dashArray: '6,6',
      },
    ).addTo(map);

    // 🎯 Fit map to both points
    map.fitBounds(line.getBounds());
  }
  createDeviationIcon(
    type: 'ais' | 'forecast',
    zoomLevel: number,
    heading: number = 0,
  ): L.DivIcon {
    const size = this.getIconSize(zoomLevel);

    // 🎨 Colors for popup use
    const hullColor = type === 'ais' ? '#22c55e' : '#3b82f6';

    return L.divIcon({
      className: 'realistic-vessel-icon',
      html: `
    <div style="
      display:flex;
      align-items:center;
      justify-content:center;
      transform: rotate(${heading}deg);
      position:relative;
    ">

      <!-- Use YOUR ship structure (slightly cleaned) -->
      <svg 
        width="${size}" 
        height="${size}" 
        viewBox="0 0 64 64"
        style="
          filter:drop-shadow(0 4px 8px rgba(0,0,0,0.4));
        "
      >

        <!-- Hull -->
        <path d="M6 42 L58 42 L48 54 L16 54 Z" fill="${hullColor}" />

        <!-- Body -->
        <rect x="18" y="26" width="28" height="16" rx="3" fill="#ffffff"/>

        <!-- Bridge -->
        <rect x="26" y="18" width="12" height="10" rx="2" fill="${hullColor}"/>

        <!-- Mast -->
        <rect x="30" y="12" width="4" height="6" fill="#374151"/>

        <!-- Front (bow highlight) -->
        <polygon points="32,4 40,18 24,18" fill="${hullColor}"/>

      </svg>

    </div>
    `,
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
    });
  }

  getIconSize(zoom: number): number {
    if (zoom <= 4) return 14;
    if (zoom <= 6) return 18;
    if (zoom <= 8) return 22;
    if (zoom <= 10) return 26;
    if (zoom <= 12) return 30;
    if (zoom <= 14) return 34;
    return 38;
  }
  goToFleet() {
    this.dialogRef.close('fleet');
    localStorage.setItem('selectedImo', this.data.imo);
    const ship = (this.data.vessel_name || '').toLowerCase();
    this.sharedDataService.setShipName(ship);
    this.router.navigate(['/vp-detailedView']);
  }
  resetAlerts(imo: any) {
    this.requestformservice.muteVesselAlert({ imo: imo }).subscribe({
      next: (res) => {
        this.toastr.success(res.message);
      },
      error: (err) => {
        console.error('Error muting vessel:', err);
      },
    });
  }
}
